//Quick View

$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});

function quickView() {
  $(".quick-view").click(function () {

    var attr = $(this).attr('data-product-id');

    // For some browsers, `attr` is undefined; for others,
    // `attr` is false.  Check for both.
    if (typeof attr !== 'undefined' && attr !== false) {
      var varId = $(this).attr('data-product-id');
      jQuery.post('/cart/add.js', {
        quantity: 1,
        id: varId
      }, null, "json").done(function () {
        $('.qv-status-title').addClass('success').html('<span>' + 'Added to cart');
        $('.qv-add-button').remove();
      })
      .fail(function ($xhr) {
        var data = $xhr.responseJSON;
        $('.qv-status-title').addClass('error').html('<span><b>ERROR: </b>' + data.description);
      });  
    }
    
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {

      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      $('.qv-product-title').text(title);
    /* $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url); */
      var imageCount = $(images).length;
      var featured_image = product.featured_image;
      var image_embed = '<img src="' + featured_image + '">';
      image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
      $('.qv-product-images').append(image_embed);
      $('.qv-product-images').css('opacity', '1');

      /* $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);

          $('.qv-product-images').slick({
            'dots': false,
            'arrows': false,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');

        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      }); */ 
      
      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div class="option-values-wrapper option-selection-' + opt.toLowerCase() + '"><p class="option">' + opt + ' : <span>' + option.values[0] + '<span></p><div class="option-' + i + ' option-list ' + opt.toLowerCase() + '"></div></div>');
        $(option.values).each(function (i, value) {
          if(i == 0){
            $('.option-list.' + opt.toLowerCase()).append('<span class="active" data-value="' + value + '">' + value + '</span>');
          }else{
            $('.option-list.' + opt.toLowerCase()).append('<span data-value="' + value + '">' + value + '</span>');
          }
        });
      });
      $(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {
          $('.qv-add-button').prop('disabled', true).val('Sold Out');
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.qv-product-price').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
      setTimeout(function(){
        if($('.qv-also-like-slider').length > 0){
          $('.qv-also-like-slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2
          }).css('opacity', '1');
        }  
      }, 1000);
    });

    $(document).on("click", "#quick-view .option-list span", function () {
      $(this).closest('.option-values-wrapper').find('.option span').text($(this).data('value'));
      $(this).closest('.option-list').find('span').removeClass('active');
      $(this).addClass('active');
      var selectedOptions = '';
      $('#quick-view .option-list').each(function (i) {
        var activeVal = $(this).find('span.active').data('value');
        if (selectedOptions == '') {
          selectedOptions = activeVal;
        } else {
          selectedOptions = selectedOptions + ' / ' + activeVal;
        }
      });
      
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            $('.qv-product-price').text('$' + price);
            $('.qv-product-original-price').text('$' + original_price);
            if (v_inv == null) {
              $('.qv-add-button').prop('disabled', false).val('Add to Cart');
            } else {
              if (v.inventory_quantity < 1) {
                $('.qv-add-button').prop('disabled', true).val('Sold Out');
              } else {
                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
              }
            }
          }
        });
      });
    });
    $.fancybox({
      href: '#quick-view',
      maxWidth: 700,
      fitToView: true,
      width: '30%',
      height: '100%',
      left: 50,
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function () {
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view .option-list').each(function (i) {
            var activeVal = $(this).find('span.active').data('value');
            if (selectedOptions == '') {
              selectedOptions = activeVal;
            } else {
              selectedOptions = selectedOptions + ' / ' + activeVal;
            }
          });
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            }, null, "json").done(function () {
              $('.qv-status-title').addClass('success').html('<span>' + 'Added to cart');
              $('.qv-product-options').remove();
              $('.qv-add-button').remove();
              /* $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>'); */
            })
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
            });
          }
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
        $('html').removeClass('Popup_Open');
      }
    });
  });
};

$(document).on('click','.qv-continue-shopping',function(){
  $('.fancybox-close').click();
});

/* $(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
}); */